<template>
  <div v-if="bannerContent" class="bg-static-success-mid">
    <RevContainer>
      <div class="flex justify-center items-center gap-4 py-2">
        <component
          :is="bannerContent.icon"
          class="w-16 shrink-0 text-static-success-hi"
        />
        <span class="body-2-bold text-static-success-hi">
          {{ bannerContent.label }}
        </span>
      </div>
    </RevContainer>
  </div>
</template>

<script lang="ts" setup>
import { computed } from 'vue'

import type { Price } from '@backmarket/core-types/Price'
import type { Deal } from '@backmarket/http-api/src/api-specs-navigation-experience/product/pickers'
import { useI18n } from '@backmarket/nuxt-module-i18n/useI18n'
import { calculateReduction } from '@backmarket/utils/math/calculateReduction'
import { RevContainer } from '@ds/components/Container'
import { IconArrowDownRightInCircleFilled } from '@ds/icons/IconArrowDownRightInCircleFilled'
import { IconBoltFilled } from '@ds/icons/IconBoltFilled'

import { normalizePrice } from '../../helpers/normalizePrice/normalizePrice'

import translations from './DealBanner.translations'

const i18n = useI18n()

const props = defineProps<{ price: Price; deal: Deal }>()

const bannerContent = computed(() => {
  if (props.deal.type === 'flash_sales') {
    return {
      label: i18n(translations.flashSalesBanner, {
        discount: i18n.price(props.deal.discount.amount, {
          trailingZeroDisplay: 'stripIfInteger',
        }),
      }),
      icon: IconBoltFilled,
    }
  }

  if (props.deal.type === 'seller_flash_sales') {
    const priceDrop = calculateReduction(
      normalizePrice(props.deal.percentage.minimumPrice),
      props.price,
    )

    if (priceDrop && parseFloat(priceDrop.amount) > 0) {
      return {
        label: i18n(translations.sellerFlashSalesBanner, {
          priceDrop: i18n.price(priceDrop),
        }),
        icon: IconArrowDownRightInCircleFilled,
      }
    }
  }

  return null
})
</script>
